<template>
<div v-can="'organizations.list'">
  <div class="search-container">
    <searchbar :value="query.search" @search="search" :model="model"></searchbar>
  </div>
  <collection @itemDelete="itemDelete" :data="items" :structure="collectionData" model="organization"></collection>
  <pagination @goToPage="goToPage" :page="page" :total-pages="total_pages"></pagination>
</div>
</template>
<script>
import Api from '@/api/Organization'
import {collectionMixin} from '@/components/mixins/Collection'
import Ui from '@/classes/Ui'
import Searchbar from '@/components/layouts/partials/Searchbar.vue'

let structure = [
  { name: 'status', type: 'status' },
  { name: 'id', sortable: true},
  { name: 'name' , type: 'show_with_edit_link' ,sortable: true},
  { name: 'users__count' },
  { name: 'action', type: 'edit_action' },
  { name: 'action_delete', type: 'delete_action' }
]

let default_sort_by = "created_at"
let default_sort_order = "DESC"
let default_filters = {}

export default {
  components: {
    Searchbar
  },
  mixins: [collectionMixin],
  mounted(){
    if (this.page != Ui.getCurrentPageOrganizations()){
      this.goToPage(Ui.getCurrentPageOrganizations())
    }
  },
  data(){
    return {
      model: "organizations",
      api: new Api(),
      collectionData: structure,
      title: "ui.pages.organizations",
      collectionMixinConfig: {
        storeResetPage: 'RESET_CURRENT_PAGE_ORGANIZATIONS',
        routerName: 'organizations',
        emptyState: 'organizations',
        default_filters: default_filters,
        default_sort_by: default_sort_by,
        default_sort_order: default_sort_order
      }
    }
  }
}
</script>
<style lang="scss">
.collection.organization{
  .table{
    table-layout: auto;
  }
  .organization-status{
    width: 5%;
  }
  .organization-id{
    width: 5%;
  }
  .organization-name{
    width: 80%;
  }
  .organization-users__count{
    width: 10%;
  }
  .organization-action{
    width: 5%;
    text-align: center;
  }
  .btn {
    padding: .7em 1.5em;
    font-size: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// Organizations.vue?d019638c